var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _polygon2, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerRectangularIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.e{fill:#3c3c46;opacity:0.15;}.c{fill:#3ca4ef;}.c,.d,.f,.g{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d{fill:#89d9fb;}.d,.e,.f,.g{fill-rule:evenodd;}.f{fill:#fff;}.g{fill:#ffefe0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-rectangular-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 27,
    y: 54,
    width: 95,
    height: 58
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 22,
    y: 46,
    width: 88,
    height: 58
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 26,
    y: 40,
    width: 88,
    height: 58
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 34,
    width: 88,
    height: 58
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "110 68 110 86 22 86 22 28 70 28 110 68"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "110 68 72.15 78.72 72.15 36.72 110 68"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "110 68 70 68 70 28 110 68"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "70 28 110 28 110 68 70 28"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerRectangularIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-rectangular-icon.77ee8d9aafd293622e228e94e742c5f8.svg";
export { ForwardRef as ReactComponent };